import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getTestList } from "../../api/api";
import CustomLoader from "../../common/loader/CustomLoader";
import { useCart } from "../../Contexts/Cart.contexts";
import "./TestPackageCss/TestPackageDetailsPage.css";
import { IoArrowBack } from "react-icons/io5";
import rbdLogo from "../../Assets/rbdLogo.png";


function TestDetailsSkeleton() {
    return (
        <div className="test-details-skeleton-container">

            <div className="test-details-skeleton-card">

                <div className="skeleton-back-btn"></div>

                <div className="skeleton-logo"></div>

                <div className="skeleton-title"></div>

                <div className="skeleton-line short"></div>
                <div className="skeleton-line"></div>
                <div className="skeleton-line"></div>

                <div className="skeleton-param-box">
                    <div className="skeleton-param-title"></div>
                    <div className="skeleton-line"></div>
                    <div className="skeleton-line short"></div>
                    <div className="skeleton-line"></div>
                </div>

                <div className="skeleton-btn-row">
                    <div className="skeleton-btn"></div>
                    <div className="skeleton-btn"></div>
                </div>

            </div>
        </div>
    );
}


export default function TestPackageDetailsPage() {
    const { serviceId } = useParams();
    const navigate = useNavigate();

    const [testData, setTestData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [copied, setCopied] = useState(false);

    const { addToCart, cartItems } = useCart();

    useEffect(() => {
        fetchTestDetails();
    }, []);

    const fetchTestDetails = async () => {
        const payload = {
            RBAuthKey: "RBDWAh!Q1s74e",
            Center_ID: "",
            search_key: "",
        };

        try {
            const res = await getTestList(payload);
            const allTests = res?.data?.data || [];
            const foundTest = allTests.find(
                (item) => item.service_id.toString() === serviceId.toString()
            );

            setTestData(foundTest);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    // COPY LINK FUNCTION
    const handleCopyLink = async () => {
        const link = `${window.location.origin}/RBD/test/${serviceId}`;

        try {
            await navigator.clipboard.writeText(link);
            setCopied(true);
            setTimeout(() => setCopied(false), 2500);
        } catch (err) {
            console.error("Copy failed:", err);
        }
    };

    const handleBookNow = () => {
        const isAdded = cartItems.some(
            (item) => item.id === testData.service_id
        );

        if (!isAdded) {
            addToCart({
                id: testData.service_id,
                product: testData.service_name,
                price: testData.price,
                quantity: 1,
            });
        }
    };

    if (loading) return <TestDetailsSkeleton />;
    if (!testData) return <h2 style={{ padding: "2rem" }}>No Test Found</h2>;

    const isAdded = cartItems.some(
        (item) => item.id === testData?.service_id
    );

    return (
        <div className="test-details-container">

            <div className="test-details-card">

                {/* BACK BUTTON */}
                <div className="backButton" onClick={() => navigate("/service/pathology")}>
                    <IoArrowBack size={22} /> Back
                </div>

                <div className="rbImage">
                    <img src={rbdLogo} alt="RB logo" />
                </div>

                <div className="fulltestDetailssec">
                    <div className="testHeadings">
                        <h2 className="test-title">{testData.service_name}</h2>

                        <p className="test-subtext">
                            <strong>Test Key:</strong> {testData.service_key}
                        </p>

                        <p className="test-price">₹ {testData.price}</p>

                        <p className="test-category">{testData?.Department}</p>
                    </div>



                    {/* PARAMETERS SECTION */}
                    <div className="parameter-box">
                        <h3 className="param-heading">Test Details</h3>

                        <p><strong>Department:</strong> {testData?.Department || "NA"}</p>

                        <p><strong>Key:</strong> {testData.service_key}</p>

                        <p><strong>Preparation:</strong> {testData?.service_preperation || "No special preparation"}</p>

                        <p><strong>Reporting Time:</strong> {testData.reportTime || "Same Day"}</p>
                    </div>
                </div>


                {/* BUTTONS */}
                <div className="button-row">
                    <button
                        className={`book-test-btn ${isAdded ? "added" : ""}`}
                        onClick={handleBookNow}
                    >
                        <span className="btn-text">{isAdded ? "Added to Cart" : "Add to Cart"}</span>
                    </button>

                    <button className="copy-btn" onClick={handleCopyLink}>
                        <span className="btn-text">{copied ? "Link Copied!" : "Copy Link"}</span>
                    </button>
                </div>

            </div>
        </div>
    );
}
